module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/banner--tribe_vote@3x-c1ca124fc916dbdd52f8c8a65b2c0618.jpg";